import { displayDate } from '@adsk/alloy-react-datetime';

import { DatePickerDate, Format } from '../types';

export default function getFieldValue({
  date,
  startDate,
  endDate,
  range,
  format,
  locale,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
}: {
  date?: DatePickerDate | null;
  startDate?: DatePickerDate | null;
  endDate?: DatePickerDate | null;
  range?: boolean;
  format?: Format;
  locale?: string;
  timeZone?: string;
}): string | null | [string | null, string | null] {
  if (range) {
    return [
      startDate
        ? displayDate(startDate, {
            format,
            locale,
            timeZone,
          })
        : null,
      endDate
        ? displayDate(endDate, {
            format,
            locale,
            timeZone,
          })
        : null,
    ];
  } else {
    return date
      ? displayDate(date, {
          format,
          locale,
          timeZone,
        })
      : null;
  }
}
